<template>
  <v-dialog
    v-model="dialog"
    max-width="30rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-list-item-content v-on="on">
        <v-list-item-subtitle>Informations du compte</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="update" v-if="data">
          <v-row dense no-gutters>
            <v-text-field
              filled
              dense
              class="no-before"
              ref="input"
              v-model="data.username"
              label="Identifiant de connexion"
              name="username"
              :rules="nameRules"
              :disabled="loading === true"
            ></v-text-field>
          </v-row>
          <v-row dense no-gutters>
            <v-text-field
              filled
              dense
              class="no-before"
              ref="input"
              v-model="data.name_store"
              label="Identifiant de succursale"
              :rules="nameRules"
              :disabled="loading === true"
            ></v-text-field>
          </v-row>
          <v-row dense no-gutters>
            <v-text-field
              filled
              dense
              class="no-before"
              ref="input"
              v-model="data.email"
              label="Courriel"
              type="email"
              :rules="emailRules"
              :disabled="loading === true"
            ></v-text-field>
          </v-row>
        </v-form>
        <v-row class="my-3" v-show="loading === true">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            color="success"
            small
            :disabled="valid === false || loading === true"
            @click="update"
          >
            <v-icon small left>fa-save</v-icon> Enregistrer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "UserBillingEditor",
  computed: {
    ...mapGetters(["getUserSettings", "getStoreId"])
  },
  data() {
    return {
      data: undefined,
      dialog: false,
      valid: false,
      loading: false,
      nameRules: [
        v => !!v || "Identifiant est requis",
        v => v.length > 5 || "Identifiant doit contenir plus que 5 charactères"
      ],
      emailRules: [
        v => !!v || "Courriel est requis",
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
          "Doit être une adresse valide"
      ]
    };
  },
  methods: {
    getData() {
      const d = this.getUserSettings;
      this.data = {
        username: d.userName,
        email: d.email,
        name_store: d.storeName
      };
    },
    async update() {
      try {
        this.loading = true;
        const userD = {
          username: this.data.username,
          email: this.data.email
        };
        const storeD = {
          name_store: this.data.name_store
        };
        const res = await Promise.all([
          this.updateUser(userD),
          this.updateStore(storeD)
        ]);
        this.$store.commit("setUsername", res[0].username);
        this.$store.commit("setUserEmail", res[0].email);
        this.$store.commit("setStoreName", res[1].name_store);
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
    async updateUser(d) {
      return await api.patchUser(d);
    },
    async updateStore(d) {
      return await api.patchStore(this.getStoreId, d);
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.getData();
      } else {
        this.data = undefined;
      }
    }
  }
};
</script>

<style></style>
